import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  Button,
  RadioSelector,
  OrganisationWrapped,
  AddressWithDuplicate,
  ErrorMsg
} from "@onegovbugs/onegov-react-components";
import {
  isCompleted,
  isSelected,
  isAustralianPhoneNumberOrNull,
  isValidEmail,
  isValidWebAddress,
  validate,
  scrollToError
} from "../../../utils/Validation";
import styles from "./Organisation.module.scss";
import {
  storeOrganisationDetail,
  saveApplication,
} from "../../../redux/actions";
import { RedirectIfCaptchaNotSelected } from "../../../utils/Redirect";
import ScrollToTop from "../../../utils/ScrollToTop";
import {clearOrganisationDetail} from "../../../redux/actions/floraFauna/organisationData";
import { getAddresUrlPath } from '../../../utils/AddressHelper';

const OrganisationDetail = (props) => {
  RedirectIfCaptchaNotSelected(props);
  ScrollToTop();

  const [showErrors, setShowErrors] = useState(false);
  const dispatch = useDispatch();

  const addressRef = useRef();
  const componentRef = React.createRef();
  const organisationDetail = useSelector((state) => state.organisationDetail);

  const [abn, setAbn] = useState(
    organisationDetail && organisationDetail.abn ? organisationDetail.abn : ""
  );
  const [acn, setAcn] = useState(
    organisationDetail && organisationDetail.acn ? organisationDetail.acn : ""
  );
  const [organisationType, setOrganisationType] = useState(
    organisationDetail && organisationDetail.organisationType
      ? organisationDetail.organisationType
      : ""
  );
  const [organisationBusinessName, setOrganisationBusinessName] = useState(
    organisationDetail && organisationDetail.organisationBusinessName
      ? organisationDetail.organisationBusinessName
      : ""
  );

  const [selectedTradingName, setSelectedTradingName] = useState(
    organisationDetail && organisationDetail.tradingName
      ? organisationDetail.tradingName
      : ""
  );
  const [dayTimePhoneNumber, setPhoneNumber] = useState(
    organisationDetail ? organisationDetail.dayTimePhoneNumber : ""
  );
  const [webAddress, setWebAddress] = useState(
    organisationDetail ? organisationDetail.webAddress : ""
  );
  const [email, setEmail] = useState(
    organisationDetail ? organisationDetail.email : ""
  );  
  const [businessAddress, setBusinessAddress] = useState(
    organisationDetail && organisationDetail.businessAddress
      ? {...organisationDetail.businessAddress}
      : {}
  );
  const [postalAddress, setPostalAddress] = useState(
    organisationDetail && organisationDetail.postalAddress
      ? {...organisationDetail.postalAddress}
      : {}
  );
  const [sameAsBusinessFlag, setSameAsBusinessFlag] = useState(
    organisationDetail && organisationDetail.isSameAsPrimaryAddress
      ? organisationDetail.isSameAsPrimaryAddress
      : false
  );
  const [isBusinessAddressValid, setBusinessAddressValid] = useState(false);
  const [isPostalAddressValid, setPostalAddressValid] = useState(false);
  const [isAddressValidating, setAddressValidating] = useState(false);

  const clearForm = () => {
    dispatch(clearOrganisationDetail({
      hasOrganisation,
      finished: true
    }));
  }

  const getFinalAdddress = (adddressValue) => {
    let finalAdddress;

    finalAdddress = {
        addressNotChanged: false,
        ...adddressValue,
      };

    return finalAdddress;
  };

  const storeData = (finished) => {
    const orgRecord = {
      hasOrganisation: hasOrganisation,
      email: email,
      dayTimePhoneNumber: dayTimePhoneNumber,
      webAddress: webAddress,
      businessAddress: getFinalAdddress(businessAddress),
      postalAddress : getFinalAdddress(postalAddress),
      organisationType: organisationType,
      abn: abn,
      acn: acn,
      organisationBusinessName: organisationBusinessName,
      isSameAsPrimaryAddress : sameAsBusinessFlag,
      finished: finished,
      step : 4
    };
    dispatch(storeOrganisationDetail(orgRecord));
  };
  const radioOptionsAssociates = [
    {
      value: "yes",
      label: "Yes",
    },
    {
      value: "no",
      label: "No",
    },
  ];

  const [hasOrganisation, setOrganisation] = useState(
    organisationDetail && organisationDetail.hasOrganisation
      ? organisationDetail.hasOrganisation
      : null
  );

  // validation

  const [errors, setErrors] = useState({
    hasOrganisation: false,
    dayTimePhoneNumber: false,
    email: false,
    addressBusiness: false,
    addressPostal: false
  });
  const validators = [
    {
      fieldName: "hasOrganisation",
      fieldValue: hasOrganisation,
      isValid: (v) => isSelected(v),
    },
    {
      fieldName: "dayTimePhoneNumber",
      fieldValue: dayTimePhoneNumber,
      isValid: (v) => hasOrganisation === 'no' ||isCompleted(v),
    },
    {
      fieldName: "IsValidDayTimePhoneNumber",
      fieldValue: dayTimePhoneNumber,
      isValid: (v) => hasOrganisation === 'no' ||isAustralianPhoneNumberOrNull(v),
    },
    {
      fieldName: "isValidEmail",
      fieldValue: email,
      isValid: (v) => hasOrganisation === 'no' ||(v !== "" || v !== null ? isValidEmail(v) : true),
    },
    {
      fieldName: "webAddress",
      fieldValue: webAddress,
      isValid: (v) => hasOrganisation === 'no' ||isValidWebAddress(v),
    },
    {
      fieldName: "addressBusiness",
      fieldValue: {
        sameAs: sameAsBusinessFlag,
        addressBusiness: businessAddress,
        addressPostal: postalAddress,
      },
      isValid: (v) =>{ let test = isBusinessAddressValid || (v.addressBusiness.lookupValue &&
        v.addressBusiness.enterManually) || hasOrganisation === 'no'
      return test}
    },
    {
      fieldName: "addressPostal",
      fieldValue: {
        sameAs: sameAsBusinessFlag,
        addressBusiness: businessAddress,
        addressPostal: postalAddress,
      },
      isValid: (v) => isPostalAddressValid || (v.addressPostal.lookupValue &&
        v.addressPostal.enterManually)  || hasOrganisation === 'no'
    }
  ];
  useEffect(() => {
    validate(validators, setErrors);
  }, [hasOrganisation, dayTimePhoneNumber, email, postalAddress, businessAddress]);

  return (
    <div className={styles.mainCont}>
      <div className={"row"}>
        <div className={"col-12"}>
          Is there any organisation associated with this application?
        </div>
      </div>
      <div className={"row"}>
        <div className={"col-12"}>
          <div className={styles.topMargin24}>
            <RadioSelector
              options={radioOptionsAssociates}
              onSelectionChange={(selectedValue) => {
                setShowErrors(false);
                setOrganisation(selectedValue);
              }}
              initialValue={hasOrganisation}
            />
            {errors.hasOrganisation && showErrors ? (
                  <ErrorMsg
                    type={"error"}
                    description={"Please make a selection."}
                  />
                ) : null}
          </div>
        </div>
      </div>
      {hasOrganisation == "yes" && (
        <>
          <hr className={styles.hrLine} />
          <div className={`row ${styles.extraMargins}`}>
            <div className={"col-12"}>
              <OrganisationWrapped
                regoType={organisationType}
                setRegoType={setOrganisationType}
                abn={abn}
                setAbn={setAbn}
                acn={acn}
                setAcn={setAcn}
                businessName={organisationBusinessName}
                setBusinessName={setOrganisationBusinessName}
                baseURL={process.env.REACT_APP_BASE_URL}
                disableYINC={true}
                hideTradingNameList={true}
                selectedTradingName={selectedTradingName}
                setSelectedTradingName={setSelectedTradingName}
                ref={componentRef}
              />
            </div>
          </div>
          <div className={"row"}>
            <div className={"col-12 col-sm-6"}>
              <label htmlFor={"phoneNumber"}>Daytime telephone number</label>
              <input
                id="inputPhoneNumber"
                className={`${styles.inputBox}`}
                placeholder={"Daytime Telephone Number"}
                value={dayTimePhoneNumber}
                onChange={(event) => {
                  setPhoneNumber(event.target.value);
                }}
                maxLength="20"
              />
              {dayTimePhoneNumber !== null &&
              dayTimePhoneNumber !== "" &&
              errors.IsValidDayTimePhoneNumber &&
              showErrors ? (
                <ErrorMsg className={"ErrorMsg_error"}
                  type={"error"}
                  description={"Day time phone number is invalid."}
                />
              ) : null}
              {errors.dayTimePhoneNumber && showErrors ? (
                <ErrorMsg className={"ErrorMsg_error"}
                  type={"error"}
                  description={"Day time phone number is required."}
                />
              ) : null}
            </div>
            <div className="col-12 col-sm-6">
              <label htmlFor={"emailAddress"}>Email address</label>
              <input
                id={"emailAddress"}
                className={styles.inputBox}
                value={email}
                onChange={(event) => {
                  setEmail(event.target.value);
                }}
                maxLength="100"
              />
               {email !== "" && errors.isValidEmail && showErrors ? (
            <ErrorMsg className={"ErrorMsg_error"} type={"error"} description={"Email is invalid."} />
          ) : null}
            </div>
          </div>
          <div className={"row"}>
            <div className={"col-12 col-sm-6"}>
              <label htmlFor={"webaddress"}>Web address (Optional)</label>
              <input
                id={"webaddress"}
                className={styles.inputBox}
                value={webAddress}
                onChange={(event) => {
                  setWebAddress(event.target.value);
                }}
                maxLength="50"
              />
              {errors.webAddress && showErrors ? (
                <ErrorMsg className={"ErrorMsg_error"}
                  type={"error"}
                  description={"Web address is invalid."}
                />
              ) : null}
            </div>
          </div>
          <br />
          <hr className={styles.hrLine} />
          <AddressWithDuplicate
            autoValidate
            international
            sameAsLabel = {"Same as Business"}
            firstAddressLabel={"Business"}
            secondAddressLabel={"Postal"}
            baseUrl= { getAddresUrlPath() }
            ref={addressRef}
            value={{
              isSameAddress: sameAsBusinessFlag,
              firstAddress: businessAddress,
              secondAddress: postalAddress
            }}
            showErrors={{
              firstAddress: showErrors && errors.addressBusiness,
              secondAddress: showErrors && errors.addressPostal,
            }}
            onChange={(data) => {
              setBusinessAddress(data.firstAddress);
              setPostalAddress(data.secondAddress);
              setSameAsBusinessFlag(data.isSameAddress);
            }}
            onValidationChange={v => {
              setBusinessAddressValid(v.firstAddressValid);
              setPostalAddressValid(v.secondAddressValid);
            }}
            onLoading={(data) => {
              setAddressValidating(
                !!(
                  data.isFirstAddressValidating ||
                  data.isSecondAddressValidating
                )
              );
            }}
          />
        </>
      )}
      <div className={`row ${styles.buttonCont}`}>
        <div className={`col-12`}>
          <Button
            disabled = {isAddressValidating}
            onClick={() => {
              var abnAcnResult = hasOrganisation === "yes" ? componentRef.current.validate() : true;
              if (validate(validators, setErrors) && abnAcnResult) {
                if(hasOrganisation === 'no') {
                  clearForm();
                }else {
                  storeData(true);
                }
                dispatch(
                  saveApplication("step4", () => {
                    props.history.push(`../../flora-fauna/dashboard`);
                  })
                );
                setShowErrors(false);
              } else {
                setShowErrors(true);
                scrollToError();
              }
            }}
          >
            Continue
          </Button>

          <Button
            secondary
            onClick={() => {
              storeData(false);
              dispatch(
                saveApplication("step4", () => {
                  props.history.push(`../../flora-fauna/dashboard`);
                })
              );
            }}
          >
            Save & exit section
          </Button>
        </div>
      </div>
    </div>
  );
};

export default withRouter((props) => <OrganisationDetail {...props} />);
